var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"heroVideo",staticClass:"d-block",attrs:{"src":require("@/assets/video/vc_photo.mp4"),"width":"100%","loop":"","gitcontrols":"","autoplay":"","muted":""},domProps:{"muted":true}}),_c('top-bar'),_c('event')],1)}
var staticRenderFns = []

export { render, staticRenderFns }